import React from 'react';

import { IconProps } from './types';

export const CellRepeatIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M13.8125 2.2344C13.4739 3.7367 12.763 5.1162 11.5697 5.9795C11.2608 6.2038 11.3327 6.665 11.6966 6.7666C13.0127 7.1221 14.1383 8.1377 14.9974 9.513"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M11.3792 6.3858C15.9241 5.1585 19.3307 6.0811 21.125 7.3125C22.1194 9.3311 22.3438 15.4375 21.125 18.6875C19.9063 19.5 18.6875 19.5 18.6875 19.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M12.1875 23.7656C12.526 22.2633 13.2369 20.8838 14.4303 20.0205C14.7392 19.7962 14.6672 19.335 14.3033 19.2334C12.9872 18.878 11.8616 17.8623 11.0026 16.487"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M14.6208 19.6142C10.0758 20.8414 6.6693 19.9189 4.875 18.6875C3.8805 16.6689 3.6562 10.5625 4.875 7.3125C5.9499 6.5 7.3125 6.5 7.3125 6.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
